export default __webpack_public_path__ + "static/media/KTML.f4e02e2c.png";